const adminTranslations = {
  fr: {
    // Sidebar
    sidebar: {
      dashboard: 'Tableau de bord',
      clients: 'Clients',
      worksites: 'Chantiers',
      quotes: 'Devis',
      invoices: 'Factures',
      leads: 'Leads',
      projects: 'Projets',
      news: 'Actualités',
      seo: 'SEO',
      employees: 'Main d\'œuvre',
      timesheets: 'Pointage',
      todos: 'Tâches',
      spreadsheet: 'Tableur',
      settings: 'Paramètres',
      language: 'Langue',
      logout: 'Déconnexion',
    },
    tour: {
      back: 'Précédent', next: 'Suivant', skip: 'Passer', last: 'Terminé', close: 'Fermer',
      helpTitle: 'Lancer le tutoriel',
      help: 'Tutoriel',
    },
    // Common
    common: {
      save: 'Enregistrer',
      saving: 'Enregistrement...',
      cancel: 'Annuler',
      create: 'Créer',
      update: 'Mettre à jour',
      edit: 'Modifier',
      delete: 'Supprimer',
      add: 'Ajouter',
      close: 'Fermer',
      search: 'Rechercher...',
      noResults: 'Aucun résultat',
      loading: 'Chargement...',
      preview: 'Aperçu',
      send: 'Envoyer',
      print: 'Imprimer / PDF',
      new: 'Nouveau',
      viewAll: 'Voir tout',
      published: 'Publié',
      draft: 'Brouillon',
      status: 'Statut',
      date: 'Date',
      name: 'Nom',
      email: 'Email',
      phone: 'Téléphone',
      address: 'Adresse',
      city: 'Ville',
      country: 'Pays',
      notes: 'Notes',
      confirm: 'Confirmer',
    },
    // Status labels
    status: {
      draft: 'Brouillon',
      sent: 'Envoyé',
      accepted: 'Accepté',
      rejected: 'Refusé',
      expired: 'Expiré',
      paid: 'Payée',
      overdue: 'En retard',
      cancelled: 'Annulée',
      new: 'Nouveau',
      contacted: 'Contacté',
      qualified: 'Qualifié',
      lost: 'Perdu',
    },
    // Dashboard
    dashboard: {
      title: 'Tableau de bord',
      subtitle: 'Vue d\'ensemble de votre activité',
      totalClients: 'Total Clients',
      activeQuotes: 'Devis actifs',
      unpaidInvoices: 'Factures impayées',
      monthlyRevenue: 'CA du mois',
      recentLeads: 'Leads récents',
      quickActions: 'Actions rapides',
      newQuote: 'Nouveau devis',
      newInvoice: 'Nouvelle facture',
      newClient: 'Nouveau client',
      noRecentLeads: 'Aucun lead récent',
    },
    // Clients
    clients: {
      title: 'Clients',
      subtitle: 'Gérez votre portefeuille clients',
      search: 'Rechercher un client...',
      new: 'Nouveau client',
      noClients: 'Aucun client trouvé',
      dossier: 'Dossier',
      editTitle: 'Modifier le client',
      newTitle: 'Nouveau client',
      form: {
        name: 'Nom *',
        company: 'Entreprise',
        nie: 'NIE / CIF / Passeport',
        niePlaceholder: 'Ex : X1234567A',
        email: 'Email *',
        phone: 'Téléphone *',
        address: 'Adresse',
        city: 'Ville',
        country: 'Pays',
        notes: 'Notes',
      },
      dossierModal: {
        quotes: 'Devis',
        invoices: 'Factures',
        totalRevenue: 'CA Total',
        noQuotes: 'Aucun devis',
        noInvoices: 'Aucune facture',
        internalNotes: 'Notes internes',
      },
      toast: {
        updated: 'Client mis à jour',
        created: 'Client créé',
        deleted: 'Client supprimé',
        errorLoad: 'Erreur lors du chargement',
        errorSave: 'Erreur lors de l\'enregistrement',
        errorDelete: 'Erreur lors de la suppression',
        confirmDelete: 'Supprimer ce client ?',
      },
    },
    // Quotes
    quotes: {
      title: 'Devis',
      subtitle: 'Gérez vos propositions commerciales',
      new: 'Nouveau devis',
      importQuote: 'Importer un devis',
      importing: 'Import en cours…',
      noQuotes: 'Aucun devis',
      previewTitle: 'Aperçu devis',
      totalTTC: 'TOTAL TTC',
      opened: 'Ouvert',
      invoice: 'Facturer',
      created: 'Créé le',
      unknownClient: 'Client inconnu',
      status: {
        draft: 'Brouillon',
        sent: 'Envoyé',
        accepted: 'Accepté',
        rejected: 'Refusé',
        expired: 'Expiré',
      },
      actions: {
        preview: 'Aperçu',
        send: 'Envoyer',
        invoice: 'Facturer',
        edit: 'Modifier',
        delete: 'Supprimer',
      },
      aiGenerate: 'Générer avec l\'IA',
      aiRefine: 'Affiner avec l\'IA',
      aiItemsGenerated: 'poste(s) généré(s)',
      aiPlaceholder: 'Ex : Augmente la maçonnerie de 10%, ajoute un poste pour l\'électricité…',
      aiHint: 'Appuyez sur Entrée pour affiner. Vous pouvez affiner plusieurs fois.',
      aiRestart: 'Recommencer',
      aiApply: 'Appliquer au devis',
      tabDescribe: 'Décrire le projet',
      tabImport: 'Importer un document',
      lineItems: {
        description: 'Description',
        quantity: 'Quantité',
        unitPrice: 'Prix unitaire',
        vatRate: 'TVA (%)',
      },
      toast: {
        updated: 'Devis mis à jour',
        created: 'Devis créé',
        deleted: 'Devis supprimé',
        sent: 'Devis envoyé par email',
        converted: 'Facture créée avec succès',
        postsGenerated: 'Postes générés — vous pouvez affiner',
        postsRefined: 'Postes affinés',
        postsApplied: 'Postes appliqués au devis',
        docAnalyzed: 'Document analysé — vous pouvez affiner',
        errorLoad: 'Erreur lors du chargement',
        errorSave: 'Erreur lors de l\'enregistrement',
        errorDelete: 'Erreur lors de la suppression',
        errorSend: 'Erreur lors de l\'envoi',
        errorConvert: 'Erreur lors de la conversion',
        errorAi: 'Erreur IA — vérifiez ANTHROPIC_API_KEY',
        confirmDelete: 'Supprimer ce devis ?',
        confirmConvert: 'Convertir ce devis en facture ? Le devis sera marqué comme Accepté.',
      },
    },
    // Invoices
    invoices: {
      title: 'Factures',
      subtitle: 'Gérez vos factures et paiements',
      new: 'Nouvelle facture',
      noInvoices: 'Aucune facture',
      previewTitle: 'Aperçu facture',
      totalTTC: 'TOTAL TTC',
      opened: 'Ouvert',
      paid: 'Payé : {amount} € | Reste : {amount} €',
      creditNote: 'Avoir · {ref}',
      paymentMethods: {
        bank_transfer: 'Virement bancaire',
        cash: 'Espèces',
        check: 'Chèque',
        card: 'Carte bancaire',
      },
      toast: {
        updated: 'Facture mise à jour',
        created: 'Facture créée',
        deleted: 'Brouillon supprimé',
        sent: 'Facture envoyée par email',
        paymentRecorded: 'Paiement enregistré',
        cancelled: 'Facture annulée — avoir émis',
        errorLoad: 'Erreur lors du chargement',
        errorSave: 'Erreur lors de l\'enregistrement',
        errorDelete: 'Seuls les brouillons peuvent être supprimés',
        errorSend: 'Erreur lors de l\'envoi',
        errorPayment: 'Erreur lors de l\'enregistrement du paiement',
        confirmDelete: 'Supprimer ce brouillon ?',
        confirmCancel: 'Annuler la facture {number} ? Un avoir sera automatiquement généré.',
      },
    },
    // Leads
    leads: {
      title: 'Leads',
      subtitle: 'Demandes reçues via le formulaire de contact',
      noLeads: 'Aucun lead',
      budget: 'Budget estimé :',
      convert: 'Convertir en client',
      converted: 'Converti en client',
      projectTypes: {
        newBuild: 'Construction neuve',
        renovation: 'Rénovation',
        pool: 'Piscine',
        outdoor: 'Extérieur',
        other: 'Autre',
      },
      toast: {
        converted: 'Lead converti en client',
        errorLoad: 'Erreur lors du chargement',
        errorConvert: 'Erreur lors de la conversion',
        confirmConvert: 'Convertir ce lead en client ?',
      },
    },
    // Projects (admin)
    projects: {
      title: 'Projets',
      subtitle: 'Gérez votre portfolio de réalisations',
      new: 'Nouveau projet',
      noProjects: 'Aucun projet',
      editTitle: 'Modifier le projet',
      newTitle: 'Nouveau projet',
      publish: 'Publier',
      hide: 'Masquer',
      form: {
        titleLabel: 'Titre du projet',
        french: 'Français *',
        spanish: 'Español',
        english: 'English',
        german: 'Deutsch',
        type: 'Type *',
        location: 'Localisation *',
        year: 'Année *',
        surface: 'Surface (m²)',
        duration: 'Durée des travaux',
        durationPlaceholder: 'Ex : 6 mois',
        descriptionFr: 'Description (français)',
        images: 'Images',
        addImage: 'Ajouter une URL',
        publishOnSite: 'Publier sur le site public',
        types: {
          newBuild: 'Construction neuve',
          renovation: 'Rénovation',
          pool: 'Piscine',
          outdoor: 'Extérieur',
          masonry: 'Maçonnerie',
        },
      },
      toast: {
        updated: 'Projet mis à jour',
        created: 'Projet créé',
        deleted: 'Projet supprimé',
        published: 'Projet publié',
        hidden: 'Projet masqué',
        errorLoad: 'Erreur lors du chargement',
        errorSave: 'Erreur lors de l\'enregistrement',
        errorDelete: 'Erreur lors de la suppression',
        confirmDelete: 'Supprimer ce projet ?',
      },
    },
    // Employees
    employees: {
      title: 'Main d\'œuvre',
      subtitle: 'employé(s)',
      new: 'Ajouter un employé',
      noEmployees: 'Aucun employé enregistré',
      noEmployeesHint: 'Ajoutez vos employés pour suivre les coûts de main d\'œuvre',
      export: 'Export :',
      exportCSV: 'Exporter CSV',
      totalCost: 'Coût total main d\'œuvre',
      hours: 'Heures',
      editTitle: 'Modifier',
      newTitle: 'Nouvel employé',
      form: {
        firstName: 'Prénom *',
        lastName: 'Nom *',
        position: 'Poste / Fonction *',
        positionPlaceholder: 'Maçon, Chef de chantier…',
        hourlyRate: 'Taux horaire (€/h) *',
        nie: 'NIE / NIF',
        niePlaceholder: 'X1234567A',
        startDate: 'Date d\'embauche',
        email: 'Email',
        phone: 'Téléphone',
        notes: 'Notes internes',
      },
      months: ['Janvier', 'Février', 'Mars', 'Avril', 'Mai', 'Juin', 'Juillet', 'Août', 'Septembre', 'Octobre', 'Novembre', 'Décembre'],
      toast: {
        updated: 'Employé mis à jour',
        created: 'Employé ajouté',
        deleted: 'Employé supprimé',
        exported: 'Export téléchargé',
        confirmDelete: 'Supprimer cet employé ?',
      },
    },
    // Settings
    settings: {
      title: 'Paramètres',
      subtitle: 'Configuration de l\'entreprise',
      companyInfo: 'Informations entreprise',
      contactInfo: 'Coordonnées',
      defaultTerms: 'Conditions par défaut',
      form: {
        legalName: 'Nom légal',
        brandName: 'Nom de marque',
        vatNumber: 'Numéro de TVA',
        defaultVatRate: 'Taux TVA par défaut (%)',
        email: 'Email',
        phone: 'Téléphone',
        address: 'Adresse',
        city: 'Ville',
        country: 'Pays',
        quoteTerms: 'Conditions devis',
        invoiceTerms: 'Conditions facture',
      },
      toast: {
        saved: 'Paramètres enregistrés',
        error: 'Erreur lors de l\'enregistrement',
      },
    },
    worksites: {
      title: 'Chantiers',
      subtitle: 'Gestion des chantiers et suivi des marges',
      newButton: 'Nouveau chantier',
      empty: 'Aucun chantier pour l\'instant.',
      createFirst: 'Créer le premier chantier',
      back: 'Retour',
      tabs: { overview: 'Marge', expenses: 'Dépenses', photos: 'Photos' },
      status: {
        planning: 'Planification', active: 'En cours', paused: 'En pause',
        completed: 'Terminé', cancelled: 'Annulé',
      },
      form: {
        editTitle: 'Modifier le chantier',
        newTitle: 'Nouveau chantier',
        name: 'Nom du chantier', namePlaceholder: 'Villa Dupont — Playa de Pals',
        client: 'Client', clientSelect: '— Sélectionner —',
        status: 'Statut', address: 'Adresse du chantier',
        startDate: 'Date début', endDate: 'Fin prévue',
        budgetTitle: 'Budget prévisionnel',
        revenue: 'Revenus estimés (€ HT)', cost: 'Coûts estimés (€ HT)',
        estimatedMargin: 'Marge estimée',
        linkedQuotes: 'Devis liés', assignedEmployees: 'Employés assignés',
        notes: 'Notes',
        cancel: 'Annuler', save: 'Enregistrer', create: 'Créer le chantier',
      },
      detail: {
        marginCard: { revenues: 'Revenus', costs: 'Coûts', actualMargin: 'Marge réelle' },
        rev: { estimated: 'Estimé', quoted: 'Devisé (validé)', invoiced: 'Facturé', paid: 'Encaissé' },
        cost: { material: 'Matière (lignes devis)', labor: 'Main d\'œuvre', additional: 'Dépenses additionnelles', total: 'Total coûts' },
        marginPct: 'de marge', estimated: 'Estimée',
        pageLoading: 'Chargement…',
        backToWorksites: 'Retour aux chantiers',
        startDate: 'Démarrage',
        plannedDelivery: 'Livraison prévue',
        realtimeSync: 'Synchro temps réel activée',
        tabs: {
          photos: 'Photos', timeline: 'Timeline', decisions: 'Décisions',
          payments: 'Paiements', documents: 'Documents', portal: 'Portail client',
        },
        photosTab: {
          pending: 'En attente', validated: 'Validées',
          portalNote: 'Les photos validées apparaissent immédiatement sur le portail client',
          emptyPending: "Aucune photo en attente — les ouvriers peuvent uploader depuis l'app Badge.",
          emptyValidated: 'Aucune photo validée pour le moment.',
          newPhotosToast: 'nouvelle(s) photo(s) à valider',
          validateBtn: 'Valider', visibleClient: 'Visible côté client',
          removePortal: 'Retirer du portail', captionPlaceholder: 'Légende (visible client)…',
          validatedToast: 'Photo validée — visible côté client', rejectedToast: 'Photo rejetée', error: 'Erreur',
        },
        timelineTab: {
          stepCount: 'étape(s) dans la timeline', addStep: 'Ajouter une étape',
          titlePlaceholder: 'Ex: Coulage des fondations', descPlaceholder: 'Description (optionnel)',
          cancel: 'Annuler', add: 'Ajouter',
          empty: "Aucune étape — ajoute la première !",
          deleteConfirm: 'Supprimer cette étape ?',
          statusPending: 'En attente', statusInProgress: 'En cours', statusCompleted: 'Terminé',
        },
        decisionsTab: {
          pendingCount: 'en attente', decidedCount: 'décidées',
          newDecision: 'Nouvelle décision',
          titlePlaceholder: 'Titre (ex: Choix carrelage salle de bain)',
          descPlaceholder: 'Contexte / description (optionnel)',
          deadline: 'Deadline', optionsLabel: 'Options (au moins 2)',
          cancel: 'Annuler', createBtn: 'Créer la décision',
          empty: 'Aucune décision créée',
          validationError: 'Titre + au moins 2 options requis',
          createdToast: 'Décision créée — visible côté client',
          deleteConfirm: 'Supprimer cette décision ?',
          clientResponse: 'Réponse client :', deadlineLabel: 'Échéance :',
          chosenByClient: 'Choisi par le client',
        },
        paymentsTab: {
          totalPlanned: 'Total prévu', collected: 'Encaissé', remaining: 'Restant à recevoir',
          instalmentCount: 'tranche(s)', addInstalment: 'Ajouter une tranche',
          labelPlaceholder: 'Libellé (ex: Acompte 10%)', amountPlaceholder: 'Montant €',
          add: 'Ajouter', empty: 'Aucune tranche définie',
          deleteConfirm: 'Supprimer cette tranche ?', paidOn: 'Payé', dueLabel: 'Échéance :',
        },
        documentsTab: {
          categories: {
            quote: 'Devis', contract: 'Contrat', permit: 'Permis',
            warranty: 'Garantie', study: 'Étude', other: 'Autre',
          },
          titlePlaceholder: 'Titre du document', uploading: 'Envoi…', uploadBtn: 'Uploader',
          empty: 'Aucun document', deleteConfirm: 'Supprimer ce document ?',
          uploadedToast: 'Document uploadé', error: 'Erreur',
        },
        portalTab: {
          inviteTitle: '📨 Inviter un client à son espace',
          inviteDesc: "Le client recevra un email avec un lien magique (pas de mot de passe). Le lien est valable 30 jours, ensuite tu peux en regénérer un.",
          namePlaceholder: 'Nom du client', sendBtn: 'Envoyer le lien', sending: 'Envoi…',
          linkSentToast: 'Magic link envoyé à',
          emailNotSentToast: 'Email non envoyé — copie le lien ci-dessous',
          linkLabel: "🔗 Lien (à copier au cas où l'email est filtré) :",
          copyBtn: 'Copier', testBtn: 'Tester', linkCopiedToast: 'Lien copié',
          activeAccess: 'Accès actifs', noAccess: 'Aucun accès actif',
          tokenExpiry: '· Expire le', seenAgo: 'Vu il y a', seenAgoMin: 'min',
          revokeTitle: 'Révoquer', revokeConfirm: 'Révoquer cet accès ?', error: 'Erreur',
        },
      },
      expenses: {
        intro: 'Dépenses hors lignes de devis (matériaux imprévus, location, sous-traitance…)',
        addButton: 'Ajouter une dépense',
        empty: 'Aucune dépense enregistrée',
        cols: { date: 'Date', type: 'Type', supplier: 'Fournisseur', description: 'Description', amount: 'Montant HT' },
        confirmDelete: 'Supprimer cette dépense ?',
        deleted: 'Dépense supprimée',
        form: {
          newTitle: 'Nouvelle dépense',
          types: { material: 'Matériaux', subcontractor: 'Sous-traitance', equipment: 'Location matériel', transport: 'Transport', admin: 'Administratif', misc: 'Divers' },
          supplier: 'Fournisseur *', description: 'Description *', amount: 'Montant HT (€) *', vat: 'TVA (%)',
          saved: 'Dépense ajoutée',
        },
      },
      photos: {
        intro: 'Photos du chantier (ajoutées par les ouvriers via l\'app badge ou ici)',
        addButton: 'Ajouter photo',
        empty: 'Aucune photo pour ce chantier',
        confirmDelete: 'Supprimer cette photo ?',
        deleted: 'Photo supprimée',
        added: 'Photo ajoutée',
      },
      toast: {
        loaded: 'Chargement des chantiers…',
        loadError: 'Erreur chargement chantiers',
        saved: 'Chantier enregistré',
        created: 'Chantier créé',
        updated: 'Chantier mis à jour',
        deleted: 'Chantier supprimé',
        error: 'Erreur enregistrement',
        confirmDelete: 'Supprimer ce chantier ? Les dépenses et photos liées seront aussi supprimées.',
        nameClientRequired: 'Nom et client requis',
      },
    },
    timesheets: {
      title: 'Pointage',
      sessions: 'session',
      sessionsPlural: 'sessions',
      onPeriod: 'sur la période',
      managePins: 'Gérer les PINs employés',
      openBadgeApp: "Ouvrir l'app Pointage",
      kpiSessions: 'Sessions',
      kpiHours: 'Heures total',
      kpiTopWorksite: 'Top chantier',
      filterFrom: 'Du',
      filterTo: 'Au',
      filterEmployee: 'Employé',
      filterWorksite: 'Chantier',
      filterAll: 'Tous',
      empty: 'Aucune session sur cette période',
      emptyHint1: 'Configurez les PINs des employés dans',
      emptyHint2: ', puis utilisez l\'',
      emptyHintApp: 'app badge',
      cols: {
        date: 'Date', employee: 'Employé', worksite: 'Chantier',
        clockIn: 'Entrée', clockOut: 'Sortie', duration: 'Durée', status: 'Statut',
      },
      statusActive: 'En cours',
      statusClosed: 'Terminé',
      errorLoad: 'Erreur lors du chargement',
    },
    news: {
      title: 'Actualités',
      subtitle: 'Articles publiés sur le site (référencement SEO)',
      newButton: 'Nouvel article',
      empty: 'Aucun article publié',
      published: 'Publié', draft: 'Brouillon',
      form: {
        editTitle: 'Modifier l\'article', newTitle: 'Nouvel article',
        articleTitle: 'Titre', slug: 'Slug (URL)', summary: 'Résumé court (meta description)',
        coverImage: 'Image de couverture', content: 'Contenu (Markdown supporté)',
        published: 'Publier', publishedAt: 'Date de publication', tags: 'Tags',
        save: 'Enregistrer', cancel: 'Annuler',
      },
      toast: { saved: 'Article enregistré', deleted: 'Article supprimé', error: 'Erreur' },
    },
    seo: {
      title: 'Suivi SEO',
      subtitle: 'Position Google des mots-clés cibles, suivi semaine après semaine, comparaison concurrents',
      tabOverview: 'Vue d\'ensemble',
      tabKeywords: 'Mots-clés',
      tabCompetitors: 'Concurrents',
    },
  },

  en: {
    sidebar: {
      dashboard: 'Dashboard',
      clients: 'Clients',
      worksites: 'Worksites',
      quotes: 'Quotes',
      invoices: 'Invoices',
      leads: 'Leads',
      projects: 'Projects',
      news: 'News',
      seo: 'SEO',
      employees: 'Labour',
      timesheets: 'Timesheets',
      todos: 'Tasks',
      spreadsheet: 'Spreadsheet',
      settings: 'Settings',
      language: 'Language',
      logout: 'Logout',
    },
    tour: {
      back: 'Back', next: 'Next', skip: 'Skip', last: 'Done', close: 'Close',
      helpTitle: 'Show tutorial',
      help: 'Tutorial',
    },
    common: {
      save: 'Save',
      saving: 'Saving...',
      cancel: 'Cancel',
      create: 'Create',
      update: 'Update',
      edit: 'Edit',
      delete: 'Delete',
      add: 'Add',
      close: 'Close',
      search: 'Search...',
      noResults: 'No results',
      loading: 'Loading...',
      preview: 'Preview',
      send: 'Send',
      print: 'Print / PDF',
      new: 'New',
      viewAll: 'View all',
      published: 'Published',
      draft: 'Draft',
      status: 'Status',
      date: 'Date',
      name: 'Name',
      email: 'Email',
      phone: 'Phone',
      address: 'Address',
      city: 'City',
      country: 'Country',
      notes: 'Notes',
      confirm: 'Confirm',
    },
    status: {
      draft: 'Draft',
      sent: 'Sent',
      accepted: 'Accepted',
      rejected: 'Rejected',
      expired: 'Expired',
      paid: 'Paid',
      overdue: 'Overdue',
      cancelled: 'Cancelled',
      new: 'New',
      contacted: 'Contacted',
      qualified: 'Qualified',
      lost: 'Lost',
    },
    dashboard: {
      title: 'Dashboard',
      subtitle: 'Overview of your business activity',
      totalClients: 'Total Clients',
      activeQuotes: 'Active Quotes',
      unpaidInvoices: 'Unpaid Invoices',
      monthlyRevenue: 'Monthly Revenue',
      recentLeads: 'Recent Leads',
      quickActions: 'Quick Actions',
      newQuote: 'New Quote',
      newInvoice: 'New Invoice',
      newClient: 'New Client',
      noRecentLeads: 'No recent leads',
    },
    clients: {
      title: 'Clients',
      subtitle: 'Manage your client portfolio',
      search: 'Search for a client...',
      new: 'New Client',
      noClients: 'No clients found',
      dossier: 'File',
      editTitle: 'Edit Client',
      newTitle: 'New Client',
      form: {
        name: 'Name *',
        company: 'Company',
        nie: 'NIE / CIF / Passport',
        niePlaceholder: 'Ex: X1234567A',
        email: 'Email *',
        phone: 'Phone *',
        address: 'Address',
        city: 'City',
        country: 'Country',
        notes: 'Notes',
      },
      dossierModal: {
        quotes: 'Quotes',
        invoices: 'Invoices',
        totalRevenue: 'Total Revenue',
        noQuotes: 'No quotes',
        noInvoices: 'No invoices',
        internalNotes: 'Internal notes',
      },
      toast: {
        updated: 'Client updated',
        created: 'Client created',
        deleted: 'Client deleted',
        errorLoad: 'Error loading clients',
        errorSave: 'Error saving',
        errorDelete: 'Error deleting',
        confirmDelete: 'Delete this client?',
      },
    },
    quotes: {
      title: 'Quotes',
      subtitle: 'Manage your commercial proposals',
      new: 'New Quote',
      importQuote: 'Import quote',
      importing: 'Importing…',
      noQuotes: 'No quotes yet',
      previewTitle: 'Quote Preview',
      totalTTC: 'TOTAL INCL. VAT',
      opened: 'Opened',
      invoice: 'Invoice',
      created: 'Created',
      unknownClient: 'Unknown client',
      status: {
        draft: 'Draft',
        sent: 'Sent',
        accepted: 'Accepted',
        rejected: 'Rejected',
        expired: 'Expired',
      },
      actions: {
        preview: 'Preview',
        send: 'Send',
        invoice: 'Invoice',
        edit: 'Edit',
        delete: 'Delete',
      },
      aiGenerate: 'Generate with AI',
      aiRefine: 'Refine with AI',
      aiItemsGenerated: 'item(s) generated',
      aiPlaceholder: 'Ex: Increase masonry by 10%, add an electrical item…',
      aiHint: 'Press Enter to refine. You can refine multiple times.',
      aiRestart: 'Restart',
      aiApply: 'Apply to quote',
      tabDescribe: 'Describe the project',
      tabImport: 'Import a document',
      lineItems: {
        description: 'Description',
        quantity: 'Quantity',
        unitPrice: 'Unit Price',
        vatRate: 'VAT (%)',
      },
      toast: {
        updated: 'Quote updated',
        created: 'Quote created',
        deleted: 'Quote deleted',
        sent: 'Quote sent by email',
        converted: 'Invoice created successfully',
        postsGenerated: 'Items generated — you can refine',
        postsRefined: 'Items refined',
        postsApplied: 'Items applied to quote',
        docAnalyzed: 'Document analysed — you can refine',
        errorLoad: 'Failed to load data',
        errorSave: 'Failed to save',
        errorDelete: 'Failed to delete',
        errorSend: 'Failed to send',
        errorConvert: 'Failed to convert',
        errorAi: 'AI error — check ANTHROPIC_API_KEY',
        confirmDelete: 'Delete this quote?',
        confirmConvert: 'Convert this quote to an invoice? The quote will be marked as Accepted.',
      },
    },
    invoices: {
      title: 'Invoices',
      subtitle: 'Manage your invoices and payments',
      new: 'New Invoice',
      noInvoices: 'No invoices yet',
      previewTitle: 'Invoice Preview',
      totalTTC: 'TOTAL INCL. VAT',
      opened: 'Opened',
      paid: 'Paid: {amount} € | Remaining: {amount} €',
      creditNote: 'Credit note · {ref}',
      paymentMethods: {
        bank_transfer: 'Bank transfer',
        cash: 'Cash',
        check: 'Cheque',
        card: 'Bank card',
      },
      toast: {
        updated: 'Invoice updated',
        created: 'Invoice created',
        deleted: 'Draft deleted',
        sent: 'Invoice sent by email',
        paymentRecorded: 'Payment recorded',
        cancelled: 'Invoice cancelled — credit note issued',
        errorLoad: 'Failed to load data',
        errorSave: 'Failed to save',
        errorDelete: 'Only drafts can be deleted (Ley Crea y Crece)',
        errorSend: 'Failed to send',
        errorPayment: 'Failed to record payment',
        confirmDelete: 'Delete this draft?',
        confirmCancel: 'Cancel invoice {number}? A credit note will be automatically generated.',
      },
    },
    leads: {
      title: 'Leads',
      subtitle: 'Requests received via the contact form',
      noLeads: 'No leads yet',
      budget: 'Estimated budget:',
      convert: 'Convert to client',
      converted: 'Converted to client',
      projectTypes: {
        newBuild: 'New Construction',
        renovation: 'Renovation',
        pool: 'Pool',
        outdoor: 'Outdoor',
        other: 'Other',
      },
      toast: {
        converted: 'Lead converted to client',
        errorLoad: 'Error loading leads',
        errorConvert: 'Error converting lead',
        confirmConvert: 'Convert this lead to a client?',
      },
    },
    projects: {
      title: 'Projects',
      subtitle: 'Manage your project portfolio',
      new: 'New Project',
      noProjects: 'No projects yet',
      editTitle: 'Edit Project',
      newTitle: 'New Project',
      publish: 'Publish',
      hide: 'Hide',
      form: {
        titleLabel: 'Project title',
        french: 'French *',
        spanish: 'Español',
        english: 'English',
        german: 'Deutsch',
        type: 'Type *',
        location: 'Location *',
        year: 'Year *',
        surface: 'Surface (m²)',
        duration: 'Work duration',
        durationPlaceholder: 'Ex: 6 months',
        descriptionFr: 'Description (French)',
        images: 'Images',
        addImage: 'Add URL',
        publishOnSite: 'Publish on the public website',
        types: {
          newBuild: 'New Construction',
          renovation: 'Renovation',
          pool: 'Pool',
          outdoor: 'Outdoor',
          masonry: 'Masonry',
        },
      },
      toast: {
        updated: 'Project updated',
        created: 'Project created',
        deleted: 'Project deleted',
        published: 'Project published',
        hidden: 'Project hidden',
        errorLoad: 'Error loading projects',
        errorSave: 'Error saving',
        errorDelete: 'Error deleting',
        confirmDelete: 'Delete this project?',
      },
    },
    employees: {
      title: 'Labour',
      subtitle: 'employee(s)',
      new: 'Add employee',
      noEmployees: 'No employees registered',
      noEmployeesHint: 'Add your employees to track labour costs',
      export: 'Export:',
      exportCSV: 'Export CSV',
      totalCost: 'Total labour cost',
      hours: 'Hours',
      editTitle: 'Edit',
      newTitle: 'New Employee',
      form: {
        firstName: 'First name *',
        lastName: 'Last name *',
        position: 'Position / Role *',
        positionPlaceholder: 'Mason, Site manager…',
        hourlyRate: 'Hourly rate (€/h) *',
        nie: 'NIE / NIF',
        niePlaceholder: 'X1234567A',
        startDate: 'Start date',
        email: 'Email',
        phone: 'Phone',
        notes: 'Internal notes',
      },
      months: ['January', 'February', 'March', 'April', 'May', 'June', 'July', 'August', 'September', 'October', 'November', 'December'],
      toast: {
        updated: 'Employee updated',
        created: 'Employee added',
        deleted: 'Employee deleted',
        exported: 'Export downloaded',
        confirmDelete: 'Delete this employee?',
      },
    },
    settings: {
      title: 'Settings',
      subtitle: 'Company configuration',
      companyInfo: 'Company Information',
      contactInfo: 'Contact Information',
      defaultTerms: 'Default Terms',
      form: {
        legalName: 'Legal company name',
        brandName: 'Brand name',
        vatNumber: 'VAT number',
        defaultVatRate: 'Default VAT rate (%)',
        email: 'Email',
        phone: 'Phone',
        address: 'Address',
        city: 'City',
        country: 'Country',
        quoteTerms: 'Quote terms',
        invoiceTerms: 'Invoice terms',
      },
      toast: {
        saved: 'Settings saved',
        error: 'Error saving settings',
      },
    },
    worksites: {
      title: 'Worksites',
      subtitle: 'Manage worksites and track margins',
      newButton: 'New worksite',
      empty: 'No worksites yet.',
      createFirst: 'Create the first worksite',
      back: 'Back',
      tabs: { overview: 'Margin', expenses: 'Expenses', photos: 'Photos' },
      status: {
        planning: 'Planning', active: 'Active', paused: 'Paused',
        completed: 'Completed', cancelled: 'Cancelled',
      },
      form: {
        editTitle: 'Edit worksite',
        newTitle: 'New worksite',
        name: 'Worksite name', namePlaceholder: 'Villa Dupont — Playa de Pals',
        client: 'Client', clientSelect: '— Select —',
        status: 'Status', address: 'Worksite address',
        startDate: 'Start date', endDate: 'Expected end',
        budgetTitle: 'Estimated budget',
        revenue: 'Estimated revenue (€ excl. VAT)', cost: 'Estimated cost (€ excl. VAT)',
        estimatedMargin: 'Estimated margin',
        linkedQuotes: 'Linked quotes', assignedEmployees: 'Assigned employees',
        notes: 'Notes',
        cancel: 'Cancel', save: 'Save', create: 'Create worksite',
      },
      detail: {
        marginCard: { revenues: 'Revenues', costs: 'Costs', actualMargin: 'Actual margin' },
        rev: { estimated: 'Estimated', quoted: 'Quoted (validated)', invoiced: 'Invoiced', paid: 'Paid' },
        cost: { material: 'Materials (quote lines)', labor: 'Labour', additional: 'Additional expenses', total: 'Total cost' },
        marginPct: 'margin', estimated: 'Estimated',
        pageLoading: 'Loading…',
        backToWorksites: 'Back to worksites',
        startDate: 'Started',
        plannedDelivery: 'Planned delivery',
        realtimeSync: 'Real-time sync enabled',
        tabs: {
          photos: 'Photos', timeline: 'Timeline', decisions: 'Decisions',
          payments: 'Payments', documents: 'Documents', portal: 'Client portal',
        },
        photosTab: {
          pending: 'Pending', validated: 'Validated',
          portalNote: 'Validated photos appear immediately on the client portal',
          emptyPending: 'No pending photos — workers can upload from the Badge app.',
          emptyValidated: 'No validated photos yet.',
          newPhotosToast: 'new photo(s) to validate',
          validateBtn: 'Validate', visibleClient: 'Visible to client',
          removePortal: 'Remove from portal', captionPlaceholder: 'Caption (visible to client)…',
          validatedToast: 'Photo validated — visible to client', rejectedToast: 'Photo rejected', error: 'Error',
        },
        timelineTab: {
          stepCount: 'step(s) in timeline', addStep: 'Add a step',
          titlePlaceholder: 'E.g.: Foundation pouring', descPlaceholder: 'Description (optional)',
          cancel: 'Cancel', add: 'Add',
          empty: 'No steps yet — add the first one!',
          deleteConfirm: 'Delete this step?',
          statusPending: 'Pending', statusInProgress: 'In progress', statusCompleted: 'Completed',
        },
        decisionsTab: {
          pendingCount: 'pending', decidedCount: 'decided',
          newDecision: 'New decision',
          titlePlaceholder: 'Title (e.g.: Bathroom tile choice)',
          descPlaceholder: 'Context / description (optional)',
          deadline: 'Deadline', optionsLabel: 'Options (at least 2)',
          cancel: 'Cancel', createBtn: 'Create decision',
          empty: 'No decisions created',
          validationError: 'Title + at least 2 options required',
          createdToast: 'Decision created — visible to client',
          deleteConfirm: 'Delete this decision?',
          clientResponse: 'Client response:', deadlineLabel: 'Deadline:',
          chosenByClient: 'Chosen by client',
        },
        paymentsTab: {
          totalPlanned: 'Total planned', collected: 'Collected', remaining: 'Remaining',
          instalmentCount: 'instalment(s)', addInstalment: 'Add instalment',
          labelPlaceholder: 'Label (e.g.: 10% deposit)', amountPlaceholder: 'Amount €',
          add: 'Add', empty: 'No instalments defined',
          deleteConfirm: 'Delete this instalment?', paidOn: 'Paid', dueLabel: 'Due:',
        },
        documentsTab: {
          categories: {
            quote: 'Quote', contract: 'Contract', permit: 'Permit',
            warranty: 'Warranty', study: 'Study', other: 'Other',
          },
          titlePlaceholder: 'Document title', uploading: 'Uploading…', uploadBtn: 'Upload',
          empty: 'No documents', deleteConfirm: 'Delete this document?',
          uploadedToast: 'Document uploaded', error: 'Error',
        },
        portalTab: {
          inviteTitle: '📨 Invite a client to their space',
          inviteDesc: 'The client will receive an email with a magic link (no password). The link is valid for 30 days, then you can regenerate one.',
          namePlaceholder: 'Client name', sendBtn: 'Send link', sending: 'Sending…',
          linkSentToast: 'Magic link sent to',
          emailNotSentToast: 'Email not sent — copy the link below',
          linkLabel: '🔗 Link (in case email is filtered):',
          copyBtn: 'Copy', testBtn: 'Test', linkCopiedToast: 'Link copied',
          activeAccess: 'Active accesses', noAccess: 'No active access',
          tokenExpiry: '· Expires', seenAgo: 'Seen', seenAgoMin: 'min ago',
          revokeTitle: 'Revoke', revokeConfirm: 'Revoke this access?', error: 'Error',
        },
      },
      expenses: {
        intro: 'Expenses outside quote line items (unforeseen materials, rentals, subcontractors…)',
        addButton: 'Add expense',
        empty: 'No expense recorded',
        cols: { date: 'Date', type: 'Type', supplier: 'Supplier', description: 'Description', amount: 'Amount excl. VAT' },
        confirmDelete: 'Delete this expense?',
        deleted: 'Expense deleted',
        form: {
          newTitle: 'New expense',
          types: { material: 'Materials', subcontractor: 'Subcontractor', equipment: 'Equipment rental', transport: 'Transport', admin: 'Administrative', misc: 'Miscellaneous' },
          supplier: 'Supplier *', description: 'Description *', amount: 'Amount excl. VAT (€) *', vat: 'VAT (%)',
          saved: 'Expense added',
        },
      },
      photos: {
        intro: 'Worksite photos (added by workers via the badge app or here)',
        addButton: 'Add photo',
        empty: 'No photo for this worksite',
        confirmDelete: 'Delete this photo?',
        deleted: 'Photo deleted',
        added: 'Photo added',
      },
      toast: {
        loaded: 'Loading worksites…',
        loadError: 'Error loading worksites',
        saved: 'Worksite saved',
        created: 'Worksite created',
        updated: 'Worksite updated',
        deleted: 'Worksite deleted',
        error: 'Save error',
        confirmDelete: 'Delete this worksite? Linked expenses and photos will also be deleted.',
        nameClientRequired: 'Name and client are required',
      },
    },
    timesheets: {
      title: 'Timesheets',
      sessions: 'session',
      sessionsPlural: 'sessions',
      onPeriod: 'on this period',
      managePins: 'Manage employee PINs',
      openBadgeApp: 'Open Badge app',
      kpiSessions: 'Sessions',
      kpiHours: 'Total hours',
      kpiTopWorksite: 'Top worksite',
      filterFrom: 'From',
      filterTo: 'To',
      filterEmployee: 'Employee',
      filterWorksite: 'Worksite',
      filterAll: 'All',
      empty: 'No session on this period',
      emptyHint1: 'Set up employee PINs in',
      emptyHint2: ', then use the ',
      emptyHintApp: 'badge app',
      cols: {
        date: 'Date', employee: 'Employee', worksite: 'Worksite',
        clockIn: 'Clock in', clockOut: 'Clock out', duration: 'Duration', status: 'Status',
      },
      statusActive: 'Active',
      statusClosed: 'Closed',
      errorLoad: 'Error loading data',
    },
    news: {
      title: 'News',
      subtitle: 'Articles published on the site (SEO)',
      newButton: 'New article',
      empty: 'No article yet',
      published: 'Published', draft: 'Draft',
      form: {
        editTitle: 'Edit article', newTitle: 'New article',
        articleTitle: 'Title', slug: 'Slug (URL)', summary: 'Short summary (meta description)',
        coverImage: 'Cover image', content: 'Content (Markdown supported)',
        published: 'Publish', publishedAt: 'Publication date', tags: 'Tags',
        save: 'Save', cancel: 'Cancel',
      },
      toast: { saved: 'Article saved', deleted: 'Article deleted', error: 'Error' },
    },
    seo: {
      title: 'SEO Tracking',
      subtitle: 'Google ranking for target keywords, weekly tracking, competitor comparison',
      tabOverview: 'Overview',
      tabKeywords: 'Keywords',
      tabCompetitors: 'Competitors',
    },
  },

  de: {
    sidebar: {
      dashboard: 'Dashboard',
      clients: 'Kunden',
      worksites: 'Baustellen',
      quotes: 'Angebote',
      invoices: 'Rechnungen',
      leads: 'Leads',
      projects: 'Projekte',
      news: 'Neuigkeiten',
      seo: 'SEO',
      employees: 'Arbeitskräfte',
      timesheets: 'Stempeluhr',
      todos: 'Aufgaben',
      spreadsheet: 'Tabelle',
      settings: 'Einstellungen',
      language: 'Sprache',
      logout: 'Abmelden',
    },
    tour: {
      back: 'Zurück', next: 'Weiter', skip: 'Überspringen', last: 'Fertig', close: 'Schließen',
      helpTitle: 'Tutorial starten',
      help: 'Tutorial',
    },
    common: {
      save: 'Speichern',
      saving: 'Speichern...',
      cancel: 'Abbrechen',
      create: 'Erstellen',
      update: 'Aktualisieren',
      edit: 'Bearbeiten',
      delete: 'Löschen',
      add: 'Hinzufügen',
      close: 'Schließen',
      search: 'Suchen...',
      noResults: 'Keine Ergebnisse',
      loading: 'Laden...',
      preview: 'Vorschau',
      send: 'Senden',
      print: 'Drucken / PDF',
      new: 'Neu',
      viewAll: 'Alle anzeigen',
      published: 'Veröffentlicht',
      draft: 'Entwurf',
      status: 'Status',
      date: 'Datum',
      name: 'Name',
      email: 'E-Mail',
      phone: 'Telefon',
      address: 'Adresse',
      city: 'Stadt',
      country: 'Land',
      notes: 'Notizen',
      confirm: 'Bestätigen',
    },
    status: {
      draft: 'Entwurf',
      sent: 'Gesendet',
      accepted: 'Akzeptiert',
      rejected: 'Abgelehnt',
      expired: 'Abgelaufen',
      paid: 'Bezahlt',
      overdue: 'Überfällig',
      cancelled: 'Storniert',
      new: 'Neu',
      contacted: 'Kontaktiert',
      qualified: 'Qualifiziert',
      lost: 'Verloren',
    },
    dashboard: {
      title: 'Dashboard',
      subtitle: 'Übersicht Ihrer Geschäftstätigkeit',
      totalClients: 'Kunden gesamt',
      activeQuotes: 'Aktive Angebote',
      unpaidInvoices: 'Offene Rechnungen',
      monthlyRevenue: 'Monatsumsatz',
      recentLeads: 'Aktuelle Leads',
      quickActions: 'Schnellaktionen',
      newQuote: 'Neues Angebot',
      newInvoice: 'Neue Rechnung',
      newClient: 'Neuer Kunde',
      noRecentLeads: 'Keine aktuellen Leads',
    },
    clients: {
      title: 'Kunden',
      subtitle: 'Verwalten Sie Ihr Kundenportfolio',
      search: 'Kunden suchen...',
      new: 'Neuer Kunde',
      noClients: 'Keine Kunden gefunden',
      dossier: 'Akte',
      editTitle: 'Kunde bearbeiten',
      newTitle: 'Neuer Kunde',
      form: {
        name: 'Name *',
        company: 'Unternehmen',
        nie: 'NIE / CIF / Reisepass',
        niePlaceholder: 'Z.B.: X1234567A',
        email: 'E-Mail *',
        phone: 'Telefon *',
        address: 'Adresse',
        city: 'Stadt',
        country: 'Land',
        notes: 'Notizen',
      },
      dossierModal: {
        quotes: 'Angebote',
        invoices: 'Rechnungen',
        totalRevenue: 'Gesamtumsatz',
        noQuotes: 'Keine Angebote',
        noInvoices: 'Keine Rechnungen',
        internalNotes: 'Interne Notizen',
      },
      toast: {
        updated: 'Kunde aktualisiert',
        created: 'Kunde erstellt',
        deleted: 'Kunde gelöscht',
        errorLoad: 'Fehler beim Laden',
        errorSave: 'Fehler beim Speichern',
        errorDelete: 'Fehler beim Löschen',
        confirmDelete: 'Diesen Kunden löschen?',
      },
    },
    quotes: {
      title: 'Angebote',
      subtitle: 'Verwalten Sie Ihre Angebote',
      new: 'Neues Angebot',
      importQuote: 'Angebot importieren',
      importing: 'Import läuft…',
      noQuotes: 'Noch keine Angebote',
      previewTitle: 'Angebotsvorschau',
      totalTTC: 'GESAMTBETRAG',
      opened: 'Geöffnet',
      invoice: 'Fakturieren',
      created: 'Erstellt am',
      unknownClient: 'Unbekannter Kunde',
      status: {
        draft: 'Entwurf',
        sent: 'Gesendet',
        accepted: 'Angenommen',
        rejected: 'Abgelehnt',
        expired: 'Abgelaufen',
      },
      actions: {
        preview: 'Vorschau',
        send: 'Senden',
        invoice: 'Fakturieren',
        edit: 'Bearbeiten',
        delete: 'Löschen',
      },
      aiGenerate: 'Mit KI generieren',
      aiRefine: 'Mit KI verfeinern',
      aiItemsGenerated: 'Position(en) generiert',
      aiPlaceholder: 'Z.B.: Mauerwerk um 10% erhöhen, Elektroposition hinzufügen…',
      aiHint: 'Enter drücken zum Verfeinern. Mehrfaches Verfeinern möglich.',
      aiRestart: 'Neu starten',
      aiApply: 'Auf Angebot anwenden',
      tabDescribe: 'Projekt beschreiben',
      tabImport: 'Dokument importieren',
      lineItems: {
        description: 'Beschreibung',
        quantity: 'Menge',
        unitPrice: 'Einzelpreis',
        vatRate: 'MwSt. (%)',
      },
      toast: {
        updated: 'Angebot aktualisiert',
        created: 'Angebot erstellt',
        deleted: 'Angebot gelöscht',
        sent: 'Angebot per E-Mail gesendet',
        converted: 'Rechnung erfolgreich erstellt',
        postsGenerated: 'Positionen generiert — Verfeinerung möglich',
        postsRefined: 'Positionen verfeinert',
        postsApplied: 'Positionen auf Angebot angewendet',
        docAnalyzed: 'Dokument analysiert — Verfeinerung möglich',
        errorLoad: 'Fehler beim Laden',
        errorSave: 'Fehler beim Speichern',
        errorDelete: 'Fehler beim Löschen',
        errorSend: 'Fehler beim Senden',
        errorConvert: 'Fehler bei der Konvertierung',
        errorAi: 'KI-Fehler — ANTHROPIC_API_KEY prüfen',
        confirmDelete: 'Dieses Angebot löschen?',
        confirmConvert: 'Angebot in Rechnung umwandeln? Das Angebot wird als Akzeptiert markiert.',
      },
    },
    invoices: {
      title: 'Rechnungen',
      subtitle: 'Verwalten Sie Ihre Rechnungen und Zahlungen',
      new: 'Neue Rechnung',
      noInvoices: 'Noch keine Rechnungen',
      previewTitle: 'Rechnungsvorschau',
      totalTTC: 'GESAMTBETRAG',
      opened: 'Geöffnet',
      paid: 'Bezahlt: {amount} € | Offen: {amount} €',
      creditNote: 'Gutschrift · {ref}',
      paymentMethods: {
        bank_transfer: 'Banküberweisung',
        cash: 'Bar',
        check: 'Scheck',
        card: 'Bankkarte',
      },
      toast: {
        updated: 'Rechnung aktualisiert',
        created: 'Rechnung erstellt',
        deleted: 'Entwurf gelöscht',
        sent: 'Rechnung per E-Mail gesendet',
        paymentRecorded: 'Zahlung erfasst',
        cancelled: 'Rechnung storniert — Gutschrift ausgestellt',
        errorLoad: 'Fehler beim Laden',
        errorSave: 'Fehler beim Speichern',
        errorDelete: 'Nur Entwürfe können gelöscht werden',
        errorSend: 'Fehler beim Senden',
        errorPayment: 'Fehler bei der Zahlungserfassung',
        confirmDelete: 'Diesen Entwurf löschen?',
        confirmCancel: 'Rechnung {number} stornieren? Eine Gutschrift wird automatisch erstellt.',
      },
    },
    leads: {
      title: 'Leads',
      subtitle: 'Anfragen über das Kontaktformular',
      noLeads: 'Noch keine Leads',
      budget: 'Geschätztes Budget:',
      convert: 'In Kunde umwandeln',
      converted: 'In Kunde umgewandelt',
      projectTypes: {
        newBuild: 'Neubau',
        renovation: 'Renovierung',
        pool: 'Pool',
        outdoor: 'Außenbereich',
        other: 'Sonstiges',
      },
      toast: {
        converted: 'Lead in Kunde umgewandelt',
        errorLoad: 'Fehler beim Laden',
        errorConvert: 'Fehler bei der Umwandlung',
        confirmConvert: 'Diesen Lead in einen Kunden umwandeln?',
      },
    },
    projects: {
      title: 'Projekte',
      subtitle: 'Verwalten Sie Ihr Projektportfolio',
      new: 'Neues Projekt',
      noProjects: 'Noch keine Projekte',
      editTitle: 'Projekt bearbeiten',
      newTitle: 'Neues Projekt',
      publish: 'Veröffentlichen',
      hide: 'Verbergen',
      form: {
        titleLabel: 'Projekttitel',
        french: 'Französisch *',
        spanish: 'Spanisch',
        english: 'Englisch',
        german: 'Deutsch *',
        type: 'Typ *',
        location: 'Standort *',
        year: 'Jahr *',
        surface: 'Fläche (m²)',
        duration: 'Baudauer',
        durationPlaceholder: 'Z.B.: 6 Monate',
        descriptionFr: 'Beschreibung (Französisch)',
        images: 'Bilder',
        addImage: 'URL hinzufügen',
        publishOnSite: 'Auf der öffentlichen Website veröffentlichen',
        types: {
          newBuild: 'Neubau',
          renovation: 'Renovierung',
          pool: 'Pool',
          outdoor: 'Außenbereich',
          masonry: 'Mauerwerk',
        },
      },
      toast: {
        updated: 'Projekt aktualisiert',
        created: 'Projekt erstellt',
        deleted: 'Projekt gelöscht',
        published: 'Projekt veröffentlicht',
        hidden: 'Projekt verborgen',
        errorLoad: 'Fehler beim Laden',
        errorSave: 'Fehler beim Speichern',
        errorDelete: 'Fehler beim Löschen',
        confirmDelete: 'Dieses Projekt löschen?',
      },
    },
    employees: {
      title: 'Arbeitskräfte',
      subtitle: 'Mitarbeiter',
      new: 'Mitarbeiter hinzufügen',
      noEmployees: 'Keine Mitarbeiter erfasst',
      noEmployeesHint: 'Fügen Sie Ihre Mitarbeiter hinzu, um Lohnkosten zu verfolgen',
      export: 'Export:',
      exportCSV: 'CSV exportieren',
      totalCost: 'Gesamte Lohnkosten',
      hours: 'Stunden',
      editTitle: 'Bearbeiten',
      newTitle: 'Neuer Mitarbeiter',
      form: {
        firstName: 'Vorname *',
        lastName: 'Nachname *',
        position: 'Position / Funktion *',
        positionPlaceholder: 'Maurer, Bauleiter…',
        hourlyRate: 'Stundenlohn (€/Std.) *',
        nie: 'NIE / NIF',
        niePlaceholder: 'X1234567A',
        startDate: 'Eintrittsdatum',
        email: 'E-Mail',
        phone: 'Telefon',
        notes: 'Interne Notizen',
      },
      months: ['Januar', 'Februar', 'März', 'April', 'Mai', 'Juni', 'Juli', 'August', 'September', 'Oktober', 'November', 'Dezember'],
      toast: {
        updated: 'Mitarbeiter aktualisiert',
        created: 'Mitarbeiter hinzugefügt',
        deleted: 'Mitarbeiter gelöscht',
        exported: 'Export heruntergeladen',
        confirmDelete: 'Diesen Mitarbeiter löschen?',
      },
    },
    settings: {
      title: 'Einstellungen',
      subtitle: 'Unternehmenskonfiguration',
      companyInfo: 'Unternehmensinformationen',
      contactInfo: 'Kontaktinformationen',
      defaultTerms: 'Standardbedingungen',
      form: {
        legalName: 'Rechtlicher Unternehmensname',
        brandName: 'Markenname',
        vatNumber: 'Steuernummer',
        defaultVatRate: 'Standard-MwSt.-Satz (%)',
        email: 'E-Mail',
        phone: 'Telefon',
        address: 'Adresse',
        city: 'Stadt',
        country: 'Land',
        quoteTerms: 'Angebotsbedingungen',
        invoiceTerms: 'Rechnungsbedingungen',
      },
      toast: {
        saved: 'Einstellungen gespeichert',
        error: 'Fehler beim Speichern',
      },
    },
    worksites: {
      title: 'Baustellen',
      subtitle: 'Baustellen verwalten und Margen verfolgen',
      newButton: 'Neue Baustelle',
      empty: 'Noch keine Baustellen.',
      createFirst: 'Erste Baustelle erstellen',
      back: 'Zurück',
      tabs: { overview: 'Marge', expenses: 'Ausgaben', photos: 'Fotos' },
      status: {
        planning: 'Planung', active: 'Aktiv', paused: 'Pausiert',
        completed: 'Abgeschlossen', cancelled: 'Storniert',
      },
      form: {
        editTitle: 'Baustelle bearbeiten',
        newTitle: 'Neue Baustelle',
        name: 'Name der Baustelle', namePlaceholder: 'Villa Dupont — Playa de Pals',
        client: 'Kunde', clientSelect: '— Auswählen —',
        status: 'Status', address: 'Adresse',
        startDate: 'Beginn', endDate: 'Voraussichtliches Ende',
        budgetTitle: 'Geschätztes Budget',
        revenue: 'Geschätzte Einnahmen (€ netto)', cost: 'Geschätzte Kosten (€ netto)',
        estimatedMargin: 'Geschätzte Marge',
        linkedQuotes: 'Verknüpfte Angebote', assignedEmployees: 'Zugewiesene Mitarbeiter',
        notes: 'Notizen',
        cancel: 'Abbrechen', save: 'Speichern', create: 'Baustelle erstellen',
      },
      detail: {
        marginCard: { revenues: 'Einnahmen', costs: 'Kosten', actualMargin: 'Tatsächliche Marge' },
        rev: { estimated: 'Geschätzt', quoted: 'Angeboten (validiert)', invoiced: 'Berechnet', paid: 'Bezahlt' },
        cost: { material: 'Material (Angebotszeilen)', labor: 'Arbeit', additional: 'Zusätzliche Ausgaben', total: 'Gesamtkosten' },
        marginPct: 'Marge', estimated: 'Geschätzt',
        pageLoading: 'Laden…',
        backToWorksites: 'Zurück zu Baustellen',
        startDate: 'Beginn',
        plannedDelivery: 'Geplante Übergabe',
        realtimeSync: 'Echtzeit-Synchronisation aktiv',
        tabs: {
          photos: 'Fotos', timeline: 'Zeitplan', decisions: 'Entscheidungen',
          payments: 'Zahlungen', documents: 'Dokumente', portal: 'Kundenportal',
        },
        photosTab: {
          pending: 'Ausstehend', validated: 'Bestätigt',
          portalNote: 'Bestätigte Fotos erscheinen sofort im Kundenportal',
          emptyPending: 'Keine ausstehenden Fotos — Arbeiter können über die Badge-App hochladen.',
          emptyValidated: 'Noch keine bestätigten Fotos.',
          newPhotosToast: 'neue Foto(s) zu prüfen',
          validateBtn: 'Bestätigen', visibleClient: 'Für Kunden sichtbar',
          removePortal: 'Vom Portal entfernen', captionPlaceholder: 'Beschriftung (für Kunden sichtbar)…',
          validatedToast: 'Foto bestätigt — für Kunden sichtbar', rejectedToast: 'Foto abgelehnt', error: 'Fehler',
        },
        timelineTab: {
          stepCount: 'Schritt(e) im Zeitplan', addStep: 'Schritt hinzufügen',
          titlePlaceholder: 'Z.B.: Fundamentguss', descPlaceholder: 'Beschreibung (optional)',
          cancel: 'Abbrechen', add: 'Hinzufügen',
          empty: 'Noch keine Schritte — ersten hinzufügen!',
          deleteConfirm: 'Diesen Schritt löschen?',
          statusPending: 'Ausstehend', statusInProgress: 'In Bearbeitung', statusCompleted: 'Abgeschlossen',
        },
        decisionsTab: {
          pendingCount: 'ausstehend', decidedCount: 'entschieden',
          newDecision: 'Neue Entscheidung',
          titlePlaceholder: 'Titel (z.B.: Fliesenauswahl Badezimmer)',
          descPlaceholder: 'Kontext / Beschreibung (optional)',
          deadline: 'Frist', optionsLabel: 'Optionen (mindestens 2)',
          cancel: 'Abbrechen', createBtn: 'Entscheidung erstellen',
          empty: 'Keine Entscheidungen erstellt',
          validationError: 'Titel + mindestens 2 Optionen erforderlich',
          createdToast: 'Entscheidung erstellt — für Kunden sichtbar',
          deleteConfirm: 'Diese Entscheidung löschen?',
          clientResponse: 'Kundenantwort:', deadlineLabel: 'Frist:',
          chosenByClient: 'Vom Kunden gewählt',
        },
        paymentsTab: {
          totalPlanned: 'Gesamt geplant', collected: 'Eingegangen', remaining: 'Noch ausstehend',
          instalmentCount: 'Rate(n)', addInstalment: 'Rate hinzufügen',
          labelPlaceholder: 'Bezeichnung (z.B.: 10% Anzahlung)', amountPlaceholder: 'Betrag €',
          add: 'Hinzufügen', empty: 'Keine Raten definiert',
          deleteConfirm: 'Diese Rate löschen?', paidOn: 'Bezahlt', dueLabel: 'Fällig:',
        },
        documentsTab: {
          categories: {
            quote: 'Angebot', contract: 'Vertrag', permit: 'Genehmigung',
            warranty: 'Garantie', study: 'Studie', other: 'Sonstiges',
          },
          titlePlaceholder: 'Dokumenttitel', uploading: 'Wird gesendet…', uploadBtn: 'Hochladen',
          empty: 'Keine Dokumente', deleteConfirm: 'Dieses Dokument löschen?',
          uploadedToast: 'Dokument hochgeladen', error: 'Fehler',
        },
        portalTab: {
          inviteTitle: '📨 Kunden einladen',
          inviteDesc: 'Der Kunde erhält eine E-Mail mit einem Magic-Link (kein Passwort). Der Link ist 30 Tage gültig, danach können Sie einen neuen generieren.',
          namePlaceholder: 'Kundenname', sendBtn: 'Link senden', sending: 'Wird gesendet…',
          linkSentToast: 'Magic-Link gesendet an',
          emailNotSentToast: 'E-Mail nicht gesendet — Link unten kopieren',
          linkLabel: '🔗 Link (falls E-Mail gefiltert wird):',
          copyBtn: 'Kopieren', testBtn: 'Testen', linkCopiedToast: 'Link kopiert',
          activeAccess: 'Aktive Zugänge', noAccess: 'Keine aktiven Zugänge',
          tokenExpiry: '· Läuft ab am', seenAgo: 'Zuletzt gesehen vor', seenAgoMin: 'Min.',
          revokeTitle: 'Widerrufen', revokeConfirm: 'Diesen Zugang widerrufen?', error: 'Fehler',
        },
      },
      expenses: {
        intro: 'Ausgaben außerhalb der Angebotszeilen (unvorhergesehene Materialien, Miete, Subunternehmer…)',
        addButton: 'Ausgabe hinzufügen',
        empty: 'Keine Ausgabe erfasst',
        cols: { date: 'Datum', type: 'Typ', supplier: 'Lieferant', description: 'Beschreibung', amount: 'Betrag netto' },
        confirmDelete: 'Diese Ausgabe löschen?',
        deleted: 'Ausgabe gelöscht',
        form: {
          newTitle: 'Neue Ausgabe',
          types: { material: 'Material', subcontractor: 'Subunternehmer', equipment: 'Gerätemiete', transport: 'Transport', admin: 'Verwaltung', misc: 'Sonstiges' },
          supplier: 'Lieferant *', description: 'Beschreibung *', amount: 'Betrag netto (€) *', vat: 'MwSt. (%)',
          saved: 'Ausgabe hinzugefügt',
        },
      },
      photos: {
        intro: 'Baustellenfotos (von Arbeitern über die Badge-App oder hier hinzugefügt)',
        addButton: 'Foto hinzufügen',
        empty: 'Kein Foto für diese Baustelle',
        confirmDelete: 'Dieses Foto löschen?',
        deleted: 'Foto gelöscht',
        added: 'Foto hinzugefügt',
      },
      toast: {
        loaded: 'Baustellen werden geladen…',
        loadError: 'Fehler beim Laden',
        saved: 'Baustelle gespeichert',
        created: 'Baustelle erstellt',
        updated: 'Baustelle aktualisiert',
        deleted: 'Baustelle gelöscht',
        error: 'Speicherfehler',
        confirmDelete: 'Diese Baustelle löschen? Verknüpfte Ausgaben und Fotos werden ebenfalls gelöscht.',
        nameClientRequired: 'Name und Kunde sind erforderlich',
      },
    },
    timesheets: {
      title: 'Stempeluhr',
      sessions: 'Sitzung',
      sessionsPlural: 'Sitzungen',
      onPeriod: 'in diesem Zeitraum',
      managePins: 'Mitarbeiter-PINs verwalten',
      openBadgeApp: 'Badge-App öffnen',
      kpiSessions: 'Sitzungen',
      kpiHours: 'Gesamtstunden',
      kpiTopWorksite: 'Top-Baustelle',
      filterFrom: 'Von',
      filterTo: 'Bis',
      filterEmployee: 'Mitarbeiter',
      filterWorksite: 'Baustelle',
      filterAll: 'Alle',
      empty: 'Keine Sitzung in diesem Zeitraum',
      emptyHint1: 'Mitarbeiter-PINs einrichten unter',
      emptyHint2: ', dann ',
      emptyHintApp: 'Badge-App',
      cols: {
        date: 'Datum', employee: 'Mitarbeiter', worksite: 'Baustelle',
        clockIn: 'Eintritt', clockOut: 'Austritt', duration: 'Dauer', status: 'Status',
      },
      statusActive: 'Aktiv',
      statusClosed: 'Geschlossen',
      errorLoad: 'Ladefehler',
    },
    news: {
      title: 'Neuigkeiten',
      subtitle: 'Auf der Website veröffentlichte Artikel (SEO)',
      newButton: 'Neuer Artikel',
      empty: 'Noch kein Artikel',
      published: 'Veröffentlicht', draft: 'Entwurf',
      form: {
        editTitle: 'Artikel bearbeiten', newTitle: 'Neuer Artikel',
        articleTitle: 'Titel', slug: 'Slug (URL)', summary: 'Kurzbeschreibung (Meta-Beschreibung)',
        coverImage: 'Titelbild', content: 'Inhalt (Markdown unterstützt)',
        published: 'Veröffentlichen', publishedAt: 'Veröffentlichungsdatum', tags: 'Tags',
        save: 'Speichern', cancel: 'Abbrechen',
      },
      toast: { saved: 'Artikel gespeichert', deleted: 'Artikel gelöscht', error: 'Fehler' },
    },
    seo: {
      title: 'SEO-Verfolgung',
      subtitle: 'Google-Ranking für Ziel-Keywords, wöchentliche Verfolgung, Wettbewerbsvergleich',
      tabOverview: 'Übersicht',
      tabKeywords: 'Keywords',
      tabCompetitors: 'Wettbewerber',
    },
  },
};

export default adminTranslations;
